export default "__VITE_ASSET__C$xYEaX9__"